// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import ColorSchemeController from './color_scheme_controller'
application.register('color-scheme', ColorSchemeController)

import CommsController from './comms_controller'
application.register('comms', CommsController)

import HelloController from './hello_controller'
application.register('hello', HelloController)

import MailToController from './mail_to_controller'
application.register('mail-to', MailToController)
